import { Component, Input } from '@angular/core';

@Component({
  selector: 'nty-cm-button',
  imports: [],
  templateUrl: './cm-button.component.html',
  styleUrls: ['./cm-button.component.scss'],
})
export class NtyCmButtonComponent {
  @Input() ntyCmButtonUrl = 'https://www.ninety.io/ninety-pricing';
}
